export default ({ app }, inject) => {
  const decodeHtmlEntities = (text) => {
    if (typeof text !== "string") {
      return text;
    }

    if (typeof window !== "undefined" && typeof DOMParser !== "undefined" && typeof document !== "undefined") {
      try {
        const parsedDoc = new DOMParser().parseFromString(`<body>${text}</body>`, "text/html");
        return parsedDoc.body.textContent || "";
      } catch (e) {
        const textarea = document.createElement("textarea");
        textarea.innerHTML = text;
        return textarea.value;
      }
    } else {
      let decodedText = text;
      const entities = {
        "&apos;": "'",
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": "\"",
        "&nbsp;": " ",
        "&copy;": "©",
        "&reg;": "®",
        "&trade;": "™",
        "&ndash;": "–",
        "&mdash;": "—",
        "&euro;": "€",
        "&pound;": "£",
        "&deg;": "°",
        "&prime;": "′",
        "&Prime;": "″",
        "&bull;": "•",
        "&hellip;": "…",
        "&lsaquo;": "‹",
        "&rsaquo;": "›",
        "&ldquo;": "“",
        "&rdquo;": "”",
        "&lsquo;": "‘",
        "&rsquo;": "’",
        "&times;": "×",
        "&divide;": "÷"
      };

      const entityKeys = Object.keys(entities)
        .map(key => key.substring(1, key.length - 1))
        .join("|");
      const namedEntitiesRegex = new RegExp(`&(${entityKeys});`, "g");

      decodedText = decodedText.replace(namedEntitiesRegex, (match) => entities[match] || match);
      decodedText = decodedText.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));
      decodedText = decodedText.replace(/&#x([0-9A-Fa-f]+);/g, (match, hex) => String.fromCharCode(parseInt(hex, 16)));
      return decodedText;
    }
  };

  inject("decodeHtmlEntities", decodeHtmlEntities);
};
